import { Button, Result } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const ChatGptContainer = () => {
  const { t } = useTranslation()
  return (
    <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Result
        icon={
          <img
            alt='bot'
            width={52}
            height={52}
            // src={'https://agora-web-cdn.oss-cn-beijing.aliyuncs.com/friday-ai/friday_head.png'}
            src={'https://web-cdn.agora.io/friday-ai/friday_head.png'}
          ></img>
        }
        title={t('taleGpt.upgrade')}
        extra={
          <Button
            type='primary'
            onClick={() => window.open('https://friday.agoralab.co/', '__blank', 'noopener,noreferrer')}
          >
            Go to F.R.I.D.A.Y
          </Button>
        }
      />
    </div>
  )
}
